// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../index';

import { MonolithImageSizeFragmentDoc } from '../../../components/monolithImageSize.fragment.generated';
import { TaxSnippetFragmentDoc } from '../../../components/rings/TaxSnippet.generated';
import { MoneyFragmentDoc } from '../fragments/money.fragment.generated';
import { AffirmFinanceOptionsFragmentDoc } from '../checkout/payment/affirmFinanceOptions.fragment.generated';
import { EngagementRingLinkFragmentDoc } from '../../../router/fragments/engagementRingLink.fragment.generated';
import { ProductPageMetaFragmentDoc } from '../../../views/product/composables/useProductPageMeta.generated';
import { AssetFragmentDoc } from '../fragments/asset.fragment.generated';
import { MetalFilterMetalFragmentDoc } from '../product/rings/fragments/filters/metalFilter.fragment.generated';
import { CatalogueEngagementRingInputFragmentDoc } from './catalogueEngagementRingInput.fragment.generated';
import { SignatureStoneInputFragmentDoc } from '../product/rings/engagement/ring/fragments/signatureStoneInput.fragment.generated';
import { StoneFragmentDoc } from '../stone/gems/fragments/stone.fragment.generated';
import { StoneCategoryFragmentDoc } from '../stone/gems/fragments/StoneCategory.fragment.generated';
import { StoneCategoryTranslationFragmentDoc } from '../stone/gems/fragments/StoneCategoryTranslation.fragment.generated';
import { StoneClarityFragmentDoc } from '../stone/gems/fragments/stoneClarity.fragment.generated';
import { ClarityTranslationFragmentDoc } from '../stone/gems/fragments/ClarityTranslation.fragment.generated';
import { StoneColorFragmentDoc } from '../stone/gems/fragments/StoneColor.fragment.generated';
import { StoneColorTranslationFragmentDoc } from '../stone/gems/fragments/StoneColorTranslation.fragment.generated';
import { StoneCrystalFragmentDoc } from '../stone/nonsku/fragments/stoneCrystal.fragment.generated';
import { StoneCrystalTranslationFragmentDoc } from '../stone/nonsku/fragments/stoneCrystalTranslation.fragment.generated';
import { StoneImageFragmentDoc } from '../stone/gems/fragments/image.fragment.generated';
import { GemsApiCertificateFragmentDoc } from '../../../domain/stone/certificate.generated';
import { GemsApiStoneAnalyticsFragmentDoc, NonSkuGemstoneAnalyticsFragmentDoc, NonSkuLabGrownAnalyticsFragmentDoc } from '../../../views/product/composables/analytics/useProductAnalytics.generated';
import { NonSkuGemstoneFragmentDoc } from '../stone/nonsku/fragments/nonSkuGemstone.fragment.generated';
import { StoneShapeFragmentDoc } from '../stone/nonsku/fragments/stoneShape.fragment.generated';
import { StoneShapeTranslationFragmentDoc } from '../stone/nonsku/fragments/stoneShapeTranslation.fragment.generated';
import { StoneCutFragmentDoc } from '../stone/nonsku/fragments/stoneCut.fragment.generated';
import { StoneCutTranslationFragmentDoc } from '../stone/nonsku/fragments/stoneCutTranslation.fragment.generated';
import { StoneGradeFragmentDoc } from '../stone/nonsku/fragments/stoneGrade.fragment.generated';
import { NonSkuGemstoneImageFragmentDoc } from '../../../domain/stone/nonSkuGemstoneImage.fragment.generated';
import { NonSkuLabGrownFragmentDoc } from '../stone/nonsku/fragments/nonSkuLabGrown.fragment.generated';
import { NonSkuLabGrownStoneImageFragmentDoc } from '../../../domain/stone/nonSkuLabGrownStoneImage.fragment.generated';
import { RecommendedRingSizeFragmentDoc } from '../product/rings/fragments/recommendedRingSize.fragment.generated';
import { RingSizeFragmentDoc } from '../product/rings/fragments/ringSize.fragment.generated';
export const RingBuilderMountEngagementRingFragmentDoc = `
    fragment ringBuilderMountEngagementRing on CatalogueEngagementRing {
  __typename
  ...engagementRingLink
  ...catalogueEngagementRingInput
  productName
  catalogueCode
  images {
    small: size(name: SMALL) {
      ...monolithImageSize
    }
    small_x2: size(name: SMALL_X2) {
      ...monolithImageSize
    }
    large: size(name: LARGE) {
      ...monolithImageSize
    }
    large_x2: size(name: LARGE_X2) {
      ...monolithImageSize
    }
  }
  primaryMetal {
    translation(locale: $locale) {
      name
    }
    systemCode
  }
  suffix
  centreStoneConstraints {
    shape {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
    weight {
      max
      min
    }
  }
  sizes(country: $country) {
    __typename
    ...recommendedRingSize
    ...ringSize
  }
}
    `;
export const RingBuilderMountFragmentFragmentDoc = `
    fragment ringBuilderMountFragment on RingBuilderMountFragment {
  __typename
  id
  ring {
    ...ringBuilderMountEngagementRing
    ...engagementRingLink
    ...productPageMeta
    variationsByCentreStoneShape {
      ...catalogueEngagementRingInput
      centreStoneConstraints {
        shape {
          systemCode
        }
      }
    }
  }
  signatureStone {
    ...signatureStoneInput
    image
    crystal {
      __typename
      translation(locale: $locale) {
        name
      }
    }
    color {
      __typename
      translation(locale: $locale) {
        name
      }
    }
    segmentName
  }
  totalSalePrice(country: $country, currency: $currency) {
    ...money
  }
}
    `;
export const RingBuilderCentreStoneFragmentFragmentDoc = `
    fragment ringBuilderCentreStoneFragment on RingBuilderCentreStoneFragment {
  __typename
  id
  stone {
    __typename
    ... on GemsApiStone {
      stone {
        ...stone
        ...gemsApiStoneAnalytics
        ...gemsApiCertificate
      }
    }
    ...nonSkuGemstone
    ...nonSkuLabGrown
    ...nonSkuGemstoneAnalytics
    ...nonSkuLabGrownAnalytics
  }
  totalSalePrice(country: $country, currency: $currency) {
    ...money
  }
}
    `;
export const RingBuilderFragmentFragmentDoc = `
    fragment ringBuilderFragment on RingBuilderFragment {
  __typename
  ... on RingBuilderMountFragment {
    ...ringBuilderMountFragment
  }
  ... on RingBuilderCentreStoneFragment {
    ...ringBuilderCentreStoneFragment
  }
}
    `;
export const RbFragmentDoc = `
    fragment rb on RingBuilder {
  __typename
  id
  productId
  position1 {
    ...ringBuilderFragment
  }
  position2 {
    ...ringBuilderFragment
  }
  errors
  image {
    url
    small: size(name: SMALL) {
      ...monolithImageSize
    }
    small_x2: size(name: SMALL_X2) {
      ...monolithImageSize
    }
    large: size(name: LARGE) {
      ...monolithImageSize
    }
    large_x2: size(name: LARGE_X2) {
      ...monolithImageSize
    }
  }
  salePrice(currency: $currency, country: $country) {
    ...taxSnippet
  }
  financeOptionsAffirm(currency: $currency, country: $country) {
    ...affirmFinanceOptions
  }
  failure {
    errors {
      __typename
    }
  }
}
    `;